import { useLiveQuery } from "dexie-react-hooks";
import { buildEmptyWeek, type MealPlanApiItem } from "@recipevault/shared";
import { db } from "../../sync/db.js";

/**
 * Read-only view of a household's week plan.
 *
 * Falls back to an empty-week skeleton (`buildEmptyWeek`) when no row exists yet in
 * Dexie — either the week hasn't synced down, or the household has never created it.
 * Viewing a week must never write one into existence; creating a row is an explicit
 * action reserved for a later task (lazy-create on first edit).
 */
export function useMealPlan(weekStart: string): MealPlanApiItem {
  const row = useLiveQuery(() => db.mealPlans.get(weekStart), [weekStart]);
  return row ?? buildEmptyWeek(weekStart, "", "");
}
